import React from 'react'
import { ReactComponent as IconWarning } from '../assets/images/alert.svg'

const Notification = ({ children, text }) => {
  return (
    <div className='notification-block'>
      <IconWarning className='notification-block__icon' />
      <p className='notification-block__text'>{text || ''}</p>
      <div className='notification-block__children'>
        {children}
      </div>
    </div>
  )
}

export default Notification